import { Component, Input } from '@angular/core';
import { ChallengeShadowBoxingService, DIFFICULTY, GEMS, TChallenge } from 'src/app/gamification/command-center/services/challenge-shadow-boxing.service';

const ChallengeShadowBoxingType = 2 as const;

@Component({
  selector: 'cv-shadow-boxing-result',
  templateUrl: './shadow-boxing-result.component.html',
  styleUrl: './shadow-boxing-result.component.scss'
})
export class ShadowBoxingResultComponent {

  @Input()
  challenge: TChallenge = {
    ChallengeType: 0,
    ChallengeEnded: false
  };

  constructor(private shadowBoxingService: ChallengeShadowBoxingService) { }

  get title() {
    if (!this.challenge.shadowBoxing) return '';
    if (this.shadowBoxingService.isChallengeWon(this.challenge.shadowBoxing))
      return 'you_win';
    if (this.challenge.shadowBoxing.newPunch) return 'Great_Punch';

    return 'Better_Luck_Next_Time';
  }

  get description() {
    if (!this.challenge.shadowBoxing) return '';
    if (this.shadowBoxingService.isChallengeWon(this.challenge.shadowBoxing))
      return 'Gems_Added';
    if (this.challenge.shadowBoxing.newPunch) return 'Keep_Punching';

    return 'Try_Again_Challenge';
  }

  get isChallengeLoss() {
    return  !this.shadowBoxingService.isChallengeWon(this.challenge.shadowBoxing) && (this.challenge.ChallengeEnded || this.challenge.ChallengeWasRemoved);
  }

  get isChallengeWon() {
    if (!this.challenge.shadowBoxing) return false;
    return this.shadowBoxingService.isChallengeWon(this.challenge.shadowBoxing);
  }

  get reward() {
    if (!this.challenge.shadowBoxing || !this.challenge.shadowBoxing.Difficulty) return 0;
    return GEMS[DIFFICULTY[this.challenge.shadowBoxing.Difficulty]];
  }

  get shouldDisplayModal() {
    const isShadowBoxing = this.challenge.ChallengeType === ChallengeShadowBoxingType;
    const shouldDisplayResults = this.challenge.shadowBoxing && !this.challenge.shadowBoxing.hiddeResults;
    if (!isShadowBoxing || !shouldDisplayResults) return false; // early return, avoid unnecesary validations

    const isNewPunch = this.challenge.shadowBoxing.newPunch;
    const isChallengeEnded = ((this.isChallengeLoss || this.isChallengeWon) && !this.challenge.isNotFirstTimeModal);
    return isNewPunch || isChallengeEnded;
  }

  closeModal() {
    if (!this.challenge.shadowBoxing) return;
    const isChallengeEnded = ((this.isChallengeLoss || this.isChallengeWon) && !this.challenge.isNotFirstTimeModal);
    this.challenge.shadowBoxing.newPunch = false;
    this.challenge.shadowBoxing.hiddeResults = true;
    if (isChallengeEnded)
      this.challenge.isNotFirstTimeModal = true;
  }

}
